import { render, staticRenderFns } from "./report-tile.vue?vue&type=template&id=36b555a9&scoped=true&"
import script from "./report-tile.vue?vue&type=script&lang=js&"
export * from "./report-tile.vue?vue&type=script&lang=js&"
import style0 from "./report-tile.vue?vue&type=style&index=0&id=36b555a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b555a9",
  null
  
)

export default component.exports